import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { formatPriceWithUserCurrency } from '../../utils/formatPrice';
import { Link as RouterLink } from 'react-router-dom';
import Slide from '@mui/material/Slide';
import { useMutation } from "react-query";


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';


import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';


import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import EditInvestment from './EditInvestment';
import CreateInvestment from './CreateInvestment';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ListInvestments() {

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }


  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


    const [investments, setInvestments] = useState(null);
    const { isLoading: isLoadinginvestments, refetch: getinvestments } = useQuery(
        "list-investments",
        async () => {
          return await apiClient.get("/api/list-investments");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setInvestments(res.data.investments);
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );
    
      useEffect(() => {
        getinvestments() 
        if (isLoadinginvestments) {
            const event3 = new Event('processing');
            window.dispatchEvent(event3);
        }
      }, []);

      const [open2, setOpen2] = React.useState(false);
      const [investmentId, setInvestmentId] = useState('');
      const [investmentStatus, setInvestmentStatus] = useState('');
      const [editOpen, setEditOpen] = useState(false);
      const [createOpen, setCreateOpen] = useState(false);
      const [selectedInvestment, setSelectedInvestment] = useState(null);

      const handleClose2 = () => {
        setOpen2(false);
      };
      const handleToggle2 = () => {
        setOpen2(!open2);
      };

      const handleEditOpen = (investment) => {
        setSelectedInvestment(investment);
        setEditOpen(true);
      };

      const handleCreateOpen = () => {
        setCreateOpen(true);
      };


      const { isLoading: isUpdating, mutate: updateInvestmentStatus } = useMutation(
        async () => {
          return await apiClient.post(`/api/update-investment`, {
            investment_id: investmentId,
            investment_status: investmentStatus,
          });
          
        },
        {
          onSuccess: (res) => {
              if (res.data.status === 'success') {
      
                localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
                setTimeout(() => {
                  const event = new Event('newMessage');
                  window.dispatchEvent(event);
                }, 1000);
      
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
                handleClose2();
                getinvestments();
                
              }            
          },
          onError: (err) => {
            let errorMessage = err.response?.data || err ;
            localStorage.setItem('notification', JSON.stringify({message : `${errorMessage.message}`, 'type': 'error' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event4 = new Event('processed');
            window.dispatchEvent(event4);
            
          },
        }
      );

      const { mutate: deleteInvestment } = useMutation(
        async (investmentId) => {
          return await apiClient.delete(`/api/admin/delete-investment/${investmentId}`);
        },
        {
          onSuccess: (res) => {
            if (res.data.status === 'success') {
              localStorage.setItem('notification', JSON.stringify({
                message: res.data.message,
                type: 'success'
              }));
              const event = new Event('newMessage');
              window.dispatchEvent(event);
              getinvestments();
            }
          },
          onError: (err) => {
            const errorMessage = err.response?.data.message || 'An error occurred';
            localStorage.setItem('notification', JSON.stringify({
              message: errorMessage,
              type: 'error'
            }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
          }
        }
      );

      const handleDelete = (investmentId) => {
        if (window.confirm('Are you sure you want to delete this investment? This action cannot be undone.')) {
          deleteInvestment(investmentId);
        }
      };


  const getDate = (date) => new Date(date).toDateString();
  return (
    <div style={{marginTop: '75px'}}>
    <Container>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 4, mb: 2 }}>
          <Typography sx={{ fontWeight: 'bold', fontSize: 20, textTransform: 'uppercase' }} variant="h6" component="div">
            {isLoadinginvestments ? 'Loading...' : 'List of investments'}
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleCreateOpen}
          >
            Create Investment
          </Button>
        </Box>
    
    <Dialog
        
        open={open2}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose2}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle sx={{textAlign: 'center'}}>{"UPDATE STATUS"}</DialogTitle>
        <DialogContent>
          <Box px={1} sx={{display: 'flex', justifyContent: 'space-evenly'}}>

          <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
            <InputLabel htmlFor="status">status</InputLabel>
                <Select
                    onChange={(e) => setInvestmentStatus(e.target.value)}
                    labelId="status"
                    id="status"
                    name="status"
                    label='status'
                    >
                    <MenuItem selected value=''>
                        select status
                    </MenuItem> 
                    <MenuItem value="pending">pending</MenuItem>
                    <MenuItem value="approved">Approved</MenuItem>
                    <MenuItem value="declined">Declined</MenuItem>
                </Select>
            </FormControl>
          </Box>          
        </DialogContent>
        
        <DialogActions>
            <Button onClick={()=>updateInvestmentStatus()} color='error'>{isUpdating? 'Updating...': 'Update Status'}</Button>
        </DialogActions>
      </Dialog>

      <EditInvestment
        open={editOpen}
        handleClose={() => setEditOpen(false)}
        investment={selectedInvestment}
        onSuccess={getinvestments}
      />

      <CreateInvestment
        open={createOpen}
        handleClose={() => setCreateOpen(false)}
        onSuccess={getinvestments}
      />


      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered>
            <Tab label="Pending Investments" {...a11yProps(0)} />
            <Tab label="Approved Investments" {...a11yProps(1)} />
            <Tab label="Completed Investments" {...a11yProps(2)} />
          </Tabs>
        </Box>
        
        <CustomTabPanel value={value} index={0}>
        <TableContainer component={Paper}>
        
        {investments !== null &&
        <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
          
          <TableCell>User Name</TableCell>
            <TableCell align="right">User Email</TableCell>
            <TableCell align="right">Amount Invested</TableCell>
            <TableCell align="right">Investment Plan</TableCell>
            <TableCell align="right">Investment Duration</TableCell>
            
            <TableCell align="right">Amount Earned</TableCell>
            <TableCell align="right">Status</TableCell>
            <TableCell align="right">Actions</TableCell>
            <TableCell align="right">Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {investments.map((investment) => (
            investment.status === 'pending' &&
            <TableRow
              key={investment.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
              {investment.user.name}
              </TableCell>
              <TableCell align="right">{investment.user.email}</TableCell>
              <TableCell align="right">{formatPriceWithUserCurrency(investment.amount_invested, investment.user)}</TableCell>
              <TableCell align="right">{investment.plan.name}</TableCell>
              <TableCell align="right">{investment.plan.duration}</TableCell>
              
              <TableCell align="right">{investment.earning}</TableCell>
              <TableCell align="right">{investment.status}</TableCell>
              <TableCell align="right">
                <Button
                  size="small"
                  onClick={() => {handleToggle2(); setInvestmentId(investment.id);}} 
                  startIcon={<ManageAccountsIcon />}
                  sx={{ mr: 1 }}
                >
                  Status
                </Button>
                <IconButton
                  size="small"
                  color="primary"
                  onClick={() => handleEditOpen(investment)}
                  sx={{ mr: 1 }}
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => handleDelete(investment.id)}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
              <TableCell align="right">{getDate(investment.created_at)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
        }
        
      </TableContainer>
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1}>
        <TableContainer component={Paper}>
        
        {investments !== null &&
        <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
          
          <TableCell>User Name</TableCell>
            <TableCell align="right">User Email</TableCell>
            <TableCell align="right">Amount Invested</TableCell>
            <TableCell align="right">Investment Plan</TableCell>
            <TableCell align="right">Investment Duration</TableCell>
            
            <TableCell align="right">Amount Earned</TableCell>
            <TableCell align="right">Status</TableCell>
            <TableCell align="right">Actions</TableCell>
            <TableCell align="right">Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {investments.map((investment) => (
            investment.status === 'approved' &&
            <TableRow
              key={investment.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
              {investment.user.name}
              </TableCell>
              <TableCell align="right">{investment.user.email}</TableCell>
              <TableCell align="right">{formatPriceWithUserCurrency(investment.amount_invested, investment.user)}</TableCell>
              <TableCell align="right">{investment.plan.name}</TableCell>
              <TableCell align="right">{investment.plan.duration}</TableCell>
              
              <TableCell align="right">{investment.earning}</TableCell>
              <TableCell align="right">{investment.status}</TableCell>
              <TableCell align="right">
                <Button
                  size="small"
                  onClick={() => {handleToggle2(); setInvestmentId(investment.id);}} 
                  startIcon={<ManageAccountsIcon />}
                  sx={{ mr: 1 }}
                >
                  Status
                </Button>
                <IconButton
                  size="small"
                  color="primary"
                  onClick={() => handleEditOpen(investment)}
                  sx={{ mr: 1 }}
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => handleDelete(investment.id)}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
              <TableCell align="right">{getDate(investment.created_at)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
        }
        
      </TableContainer>
        </CustomTabPanel>

        <CustomTabPanel value={value} index={2}>
        <TableContainer component={Paper}>
        
        {investments !== null &&
        <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
          
          <TableCell>User Name</TableCell>
            <TableCell align="right">User Email</TableCell>
            <TableCell align="right">Amount Invested</TableCell>
            <TableCell align="right">Investment Plan</TableCell>
            <TableCell align="right">Investment Duration</TableCell>
            
            <TableCell align="right">Amount Earned</TableCell>
            <TableCell align="right">Status</TableCell>
            <TableCell align="right">Actions</TableCell>
            <TableCell align="right">Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {investments.map((investment) => (
            investment.status === 'completed' &&
            <TableRow
              key={investment.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
              {investment.user.name}
              </TableCell>
              <TableCell align="right">{investment.user.email}</TableCell>
              <TableCell align="right">{formatPriceWithUserCurrency(investment.amount_invested, investment.user)}</TableCell>
              <TableCell align="right">{investment.plan.name}</TableCell>
              <TableCell align="right">{investment.plan.duration}</TableCell>
              
              <TableCell align="right">{investment.earning}</TableCell>
              <TableCell align="right">{investment.status}</TableCell>
              <TableCell align="right">
                <Button
                  size="small"
                  onClick={() => {handleToggle2(); setInvestmentId(investment.id);}} 
                  startIcon={<ManageAccountsIcon />}
                  sx={{ mr: 1 }}
                >
                  Status
                </Button>
                <IconButton
                  size="small"
                  color="primary"
                  onClick={() => handleEditOpen(investment)}
                  sx={{ mr: 1 }}
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => handleDelete(investment.id)}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
              <TableCell align="right">{getDate(investment.created_at)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
        }
        
      </TableContainer>
        </CustomTabPanel>
      </Box>
      </Container>
    </div>
  );
}